var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotswana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.07 71.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m40.68 1.5.3.76-.15.6.15.53v.76l1.06.83.53.53.91.6.6.84.15.75.38.23.76 1.21.3 1.28.68.69.3 1.05.83.68.38-.07.53 1.06L50.51 17l1.36.84 1.29.98.68.6.98.61.08.38-.16.45.31.76 1.28.45 1.14.83-.38.99.3 1.66.15 1.13.45 1.21 1.37 1.06.75 1.21 1.59.31.83-.31 1.89.61.99.07 1.36.91h.98l.68.61v.75l.46.68.68.69-.91.15-.68.53h-1.29l-.75.68.15.68-.38 1.13-1.06.23-.98.98h-1.21l-.68.15-.46-.3-1.51.3-1.59 1.29-.68.75-.91.53-.3.68-1.06.31-.6.68-.68.23-1.06.45-1.97 2.65-.23 1.81.38.53v1.13l-.98.23-.45.61-.76.22-1.06.84-.38.98-.45.3-.45.68-.99.08-.98.68-1.51.3-.61 1.21.08 1.89-.68.76v.9l-.46 1.29.46.61-1.67.98-.83-.38-.6-.68-1.14.15h-1.74l-1.51.38-1.29-.45-1.13.22-2.65-1.51-.83-.08-.76-.9-2.42-.38-1.81.23-1.89 1.74-1.21 2.87-1.29 1.36-2.42.98-.53.84-1.36 1.13-1.51.38-1.21.75-1.67-.22-1.21.53-1.89-.38-1.96.23.07-1.37 1.06-2.34v-1.97L4.6 59.66l-.68-1.97-2.42-1.81v.07-.22l1.29-22.92 6.42-.08L10.5 6.64l5.45.23 6.95-1.66 2.2-.61.98-.07.3-.16.46.23.37 1.06.53.53-.38.53-.15.98.61.15 2.34-1.66 1.44-1.82 1.44-1.43 1.59-.23.37.6.91.08.91-.6 2.34-.84 1.52-.37z",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotswana);
export default __webpack_public_path__ + "static/media/botswana.39e9706ca367710acc2b913500702b75.svg";
export { ForwardRef as ReactComponent };